import React from "react"

import { Card, CardBody } from "reactstrap"

import ScheduleForm from "./components/ScheduleForm"
import ClassesGradeCard from "./components/ClassesGradeCard"
import { useClassesPage } from "./hooks/useClassesPage"

import { ContentLoader, OverlayLoader, Breadcrumb } from "../../../components/Common"
import "./Classes.css"

const ClassesPage = () => {

  const {
    formState,
    setFormState,
    errors,
    touched,
    activities,
    areas,
    employees,
    schedulesForGrid,
    isInitialLoading,
    isSaving,
    isReady,
    turn,
    setTurn,
    view,
    setView,
    referenceDate,
    setReferenceDate,
    handleSave,
    handleDelete,
    handleClassClick,
    handleWeekdayToggle,
    handleStartTimeChange,
    handleDurationChange,
  } = useClassesPage()


  if (!isReady || isInitialLoading) {
    return <ContentLoader message="Carregando Turmas..." />
  }

  return (
    <React.Fragment>
      <div className="d-flex align-items-center justify-content-between mb-3">
          <Breadcrumb title="Turmas" />
      </div>

      <div className="border-top mb-3"></div>
      
      <Card className="class-form-card mb-4 border-0 shadow-sm overflow-hidden position-relative rounded-0">
        <CardBody className="p-4 p-md-5">
          <OverlayLoader show={isSaving} label="Salvando..." />
          <ScheduleForm
            values={formState}
            errors={errors}
            touched={touched}
            handleChange={(e) => {
              const { name, value } = e.target
              setFormState((prev) => ({ ...prev, [name]: value }))
            }}
            setFieldValue={(field, value) =>
              setFormState((prev) => ({ ...prev, [field]: value }))
            }
            handleWeekdayToggle={handleWeekdayToggle}
            handleStartTimeChange={handleStartTimeChange}
            handleDurationChange={handleDurationChange}
            activities={activities}
            employees={employees}
            areas={areas}
            disabled={isSaving}
            onSave={handleSave}
            onDelete={formState.id ? handleDelete : undefined}
            saving={isSaving}
          />
        </CardBody>
      </Card>

      <div className="classes-page-grid">
        <ClassesGradeCard
          turn={turn}
          onTurnChange={setTurn}
          view={view}
          onViewChange={setView}
          referenceDate={referenceDate}
          onReferenceDateChange={setReferenceDate}
          schedules={schedulesForGrid}
          onClassClick={handleClassClick}
          selectedClassId={formState.id || null}
          loading={false}
        />
      </div>
    </React.Fragment>
  )
}

export default ClassesPage
